export default {"src":"/_next/static/media/vodafone-tv.d244ed7c.svg","height":100,"width":100};